class EventBus extends EventTarget {
  emit(eventType: string, payload?: object | null | undefined): void {
    const customEvent = new CustomEvent(eventType, { detail: payload });
    this.dispatchEvent(customEvent);
  }

  on<T extends string>(
    eventType: T,
    handler: (payload: object | null | undefined) => void
  ): () => void {
    const callback = (event: Event) => {
      const { detail } = event as CustomEvent;
      handler(detail);
    };

    this.addEventListener(eventType, callback);

    return () => this.removeEventListener(eventType, callback);
  }
}

export default new EventBus();
